// Design tokens for the hero pages.
// Shared across the page components, edit forms, and the styled primitives.
// The brand coral lives in the MUI theme (theme.palette.primary) — read it via
// useTheme() rather than adding it here, so the primary color has one source.
export const TEXT_DARK = '#1a1a1a';
export const TEXT_BODY = '#333';
export const TEXT_SECONDARY = '#666';
export const MUTED = '#999';
export const SUCCESS = '#4CAF50';
export const ERROR = '#f44336';
export const BORDER = '#d1d5db';
export const HAIRLINE = '#eee';

// A control's border while the pointer is over it, before focus takes it green.
export const BORDER_HOVER = '#9e9e9e';

// Pressed/hover shades for the status colors, the way primary.dark serves the
// brand coral. Only filled surfaces need them — an outline or a focus ring
// keeps its base color on hover.
export const SUCCESS_HOVER = '#43a047';
export const ERROR_HOVER = '#d32f2f';

// Status colors for a filled surface carrying a white label — the snackbars.
// Darker than the base tokens on purpose: white on SUCCESS is around 2:1, which
// doesn't read. Pick these whenever the color is the background rather than the
// mark, and leave the base tokens to borders, icons and focus rings.
export const SUCCESS_FILLED = '#2e9e5b';
export const ERROR_FILLED = '#e5484d';
export const WARNING_FILLED = '#d9822b';
export const INFO_FILLED = '#3c3c3c';

// Text on the app's own controls — header chips, drawer rows, outlined buttons.
export const CONTROL_TEXT = '#3c3c3c';

// The dark chrome bars — the filter bar above a grid, the floating selection
// bar.
export const BAR_BG = '#3C3C3C';
export const BAR_BORDER = '#2f2f2f';
export const BAR_DIVIDER = '#5a5a5a';
export const BAR_TEXT_MUTED = '#cfcfcf';

// Content height of the app header. The drawer's own header matches it so the
// logo sits on the same line whether the drawer is open or closed.
export const HEADER_CONTENT_HEIGHT = 42;

// The "published" blue: the filled share glyph, and anything else marking an
// entity as living in the public namespace.
export const PUBLISHED_BLUE = '#1565c0';

// The link blue a clickable name takes on hover inside a card — an author or
// site that navigates.
export const LINK_BLUE = '#0066cc';
export const LINK_BLUE_BG = '#f0f7ff';

// The small metric pill.
export const PILL_BORDER = '#e0e0e0';
export const PILL_TEXT = '#555';

// Card and hover-card excerpts, set in the serif.
export const EXCERPT_TEXT = '#555';

// Something not real yet — a tag mid-create, a synthetic pseudo-tag, the empty
// state where tags would be.
export const DRAFT_TEXT = '#6b7280';

// The unsettled amber - a proposed tag with no public match yet, and the
// warning that renaming onto an existing name merges the two irreversibly.
export const WARNING = '#f59e0b';
export const WARNING_BG = '#fff8e1';
export const WARNING_BORDER = '#ffe082';
export const WARNING_TITLE = '#92400e';
export const WARNING_BODY = '#78350f';
export const WARNING_HINT = '#b45309';

// Dialog family (Import, Add-to-list, …) chrome — headers, footers, focus rings.
export const DIVIDER = '#eef0f2';
export const HOVER_BG = '#f5f5f5';
export const FOOTER_BG = '#f8f9fa';
export const FOCUS_RING = '0 0 0 4px rgba(76,175,80,0.12)';

// Shared font size for every edit-mode field (matches the excerpt editor).
export const EDIT_FONT_SIZE = '1.05rem';

// The editorial serif: every card and hero title, and the initials standing in
// for a missing portrait. Everything else is the Roboto body face.
export const SERIF_STACK = "'Merriweather', Georgia, serif";

// The workhorse sans — everything SERIF_STACK doesn't set.
export const SANS_STACK = "'Roboto', sans-serif";

// The condensed face — the app-bar wordmark and the heat/buzz badge, where a
// number has to hold its width. Falls back to regular Roboto, so a failed
// webfont narrows rather than reflowing into a different family.
export const CONDENSED_STACK = "'Roboto Condensed', Roboto, sans-serif";
